export default "__VITE_ASSET__131eb269__"